// Generated by CoffeeScript 2.7.0
var Year;

export default Year = {
  props: {
    displayRange: {
      type: Array,
      default: function() {
        return [];
      }
    },
    initValue: {
      type: Date,
      default: function() {
        return new Date();
      }
    }
  },
  template: `<div class="picker-view">
  <div class="picker-row" v-for='(years, index) in displayRange' :key='index'>
    <div class="picker-item"
          v-for='y in years'
          :class='computeItemClass(y)'
          :key='y.key'
          @click='update(y)'>
      <div class="picker-value">{{ y.text }}</div>
    </div>
  </div>
</div>`,
  methods: {
    update: function(y) {
      return this.$emit('update', y);
    },
    computeItemClass: function(y) {
      return [
        y.status,
        {
          active: this.initValue.getFullYear() === y.key
        }
      ];
    }
  }
};
